import type { ProvinceDTO } from "../../api/contract";
import { apiGet } from "./http";

export function listProvinces(): Promise<ProvinceDTO[]> {
  return apiGet<ProvinceDTO[]>("/api/provinces");
}
